export enum ErrorValidateMessage {
  Required = 'This field is required',
  MinLength = 'Minimum 8 characters required',
  Validate = 'Passwords must match',
  Pattern = 'Wrong or Invalid email address',
}
